<template>
  <Tab no-help @close="removeCurrent">
    <template #toolbar-help>
      <v-btn class="tw-mr-2" fab text x-small :title="$t('dashboard.help.show')" @click="showHelp(menu,page)">
            <span class="mr-1">
              <v-icon color="primary" x-small>fa fa-question</v-icon>
            </span>
      </v-btn>
    </template>
    <template #toolbar-help>
      <v-btn class="tw-mr-2" fab text x-small :title="$t('dashboard.help.show')" @click="showHelp(menu,page)">
            <span class="mr-1">
              <v-icon color="primary" x-small>fa fa-question</v-icon>
            </span>
      </v-btn>
    </template>
    <template #toolbar-items>
      <!-- ------------------------ profiles des modérateurs ------------------------ -->
      <TabToolbarButton
        v-model="page"
        :menu="menu"
        :selected="page === 'profiles'"
        icon="fa-users"
        name="profiles"
      ></TabToolbarButton>
      <!-- ------------------------ Comportement des avis site/site ------------------------ -->
      <TabToolbarButton
        v-model="page"
        :menu="menu"
        :selected="page === 'reviews_params'"
        icon="fa-splotch"
        name="reviews_params"
      ></TabToolbarButton>
      <!-- ------------------------ Liste des thématiques ------------------------ -->
      <TabToolbarButton
          v-model="page"
          :menu="menu"
          :selected="page === 'thematics_params'"
          icon="fa-clipboard-check"
          name="thematics_params"
      ></TabToolbarButton>
    </template>
    <template #container>
      <v-snackbar
          v-model="snackbar"
          :color="snackbarColor"
          :timeout="snackbarTimeout"
          :multi-line="true"
          text
          outlined
          tile
          app
          top
      >
        {{ snackbarText }}
        <template v-slot:action="{ attrs }">
          <v-btn icon @click="snackbar = false">
            <v-icon :color="snackbarColor" small>fa-times</v-icon>
          </v-btn>
        </template>
      </v-snackbar>
      <!-- ------------------------ profiles des modérateurs ------------------------ -->
      <TabPage :menu="menu" :page="page" name="profiles" no-documentation>
        <template #content>
          <v-row>
            <!-- Profiles list -->
            <v-col cols="12" lg="4" md="6">
              <v-card>
                <v-container>
                  <span class="sr-title">
                    <!-- List title -->
                    {{ $t("parameters.profiles.title") }}
                  </span>
                  <v-btn style="position: absolute;right: 20px; top: 10px;" :title="$t('parameters.profiles.refresh')" icon @click="fetchProfiles">
                    <v-icon x-small>
                      fa-sync-alt
                    </v-icon>
                  </v-btn>
                </v-container>
                <v-container>
                  <v-btn color="primary" small @click="newProfile">{{ $t("parameters.profiles.new") }}</v-btn>
                </v-container>
                <v-card-text v-if="profiles.length > 0" class="pa-0">
                  <v-list subheader two-line>
                    <!-- Scrollable list of profiles -->
                    <v-list-item-group
                      v-model="selectedProfile"
                      active-class="blue--text"
                      style="height: calc(100vh - 300px);overflow-y: auto;"
                    >
                      <v-list-item v-for="itemProfile in profiles" :key="itemProfile.id">
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ itemProfile.name }}
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            {{ itemProfile.public_id }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-card-text>
                <v-card-text v-else-if="profiles.length <= 0">
                  {{ $t("parameters.profiles.nothing") }}
                </v-card-text>
              </v-card>
            </v-col>
            <v-col v-if="profile" cols="12" lg="8" md="6">
              <v-card>
                <v-container>
                  <span class="sr-title">
                    <!-- List title -->
                    {{ $t("parameters.profiles.selected") }}
                  </span>
                </v-container>
                <v-card-text v-if="creatorMode">
                  <v-text-field v-model="profile.name" :label="$t('parameters.profiles.name')"></v-text-field>
                  <v-btn color="primary" small @click="createProfile">{{ $t("parameters.profiles.create") }}</v-btn>
                  <v-btn class="ml-2" small @click="cancelProfile">{{ $t("parameters.profiles.cancel") }}</v-btn>
                </v-card-text>
                <v-card-text v-else>
                  <v-text-field v-model="profile.name" :label="$t('parameters.profiles.name')"></v-text-field>
                  <v-text-field
                    :label="$t('parameters.profiles.public_id')"
                    :value="profile.public_id"
                    readonly
                  ></v-text-field>
                  <div v-if="counters.length > 0">
                    <div class="sr-title">{{ $t("invitation.tracking.list.infos.title") }}</div>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <template v-for="itemCounters in counters">
                              <th
                                v-for="counter in itemCounters"
                                :key="counter.month + '' + counter.year"
                                class="text-left"
                              >
                                {{ $t("invitation.tracking.list.infos." + counter.month) }} {{ counter.year }}
                              </th>
                            </template>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <template v-for="itemCounters in counters">
                              <td v-for="counter in itemCounters" :key="counter.month + '' + counter.year">
                                <div>
                                  <strong>{{ $t("invitation.tracking.list.infos.total") }}:</strong>
                                  {{ counter.total_count }}
                                </div>
                                <div>
                                  <strong>{{ $t("invitation.tracking.list.infos.not_pending") }}:</strong>
                                  {{ counter.total_count - counter.pending_count }}
                                </div>
                                <div v-if="counter.hasOwnProperty('total_count')">
                                  <strong>{{ $t("invitation.tracking.list.infos.percentage") }}:</strong>
                                  {{
                                    Math.ceil(
                                      ((counter.total_count - counter.pending_count) / counter.total_count) * 100
                                    ).toFixed(0)
                                  }}%
                                </div>
                              </td>
                            </template>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </div>
                  <div class="mt-4 mb-6 tw-flex">
                    <div>
                      <span class="font-weight-bold">{{ $t("parameters.profiles.created_at") }}:</span>
                      <span> {{ profile.created_at }}</span>
                    </div>
                    <div class="ml-4">
                      <span class="font-weight-bold">{{ $t("parameters.profiles.updated_at") }}:</span>
                      <span> {{ profile.updated_at }}</span>
                    </div>
                  </div>
                  <div class="tw-flex tw-justify-between tw-items-center">
                    <div>
                      <v-btn color="primary" small @click="updateProfile">{{ $t("parameters.profiles.update") }}</v-btn>
                      <v-btn class="ml-2" small @click="cancelProfile">{{ $t("parameters.profiles.cancel") }}</v-btn>
                    </div>
                    <v-btn class="ml-2" color="error" small @click="deleteProfile"
                      >{{ $t("parameters.profiles.delete") }}
                    </v-btn>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </template>
      </TabPage>
      <!-- ------------------------ Comportement des avis site/site ------------------------ -->
      <TabPage :menu="menu" :page="page" documentation-path="manager/publications/params/page" name="reviews_params">
        <template #websiteWrapper>
          <WebsiteWrapper
              @selected="params.website_id = $event.id; loadWebsitePublicationsParams();"
              @back="params.website_id = 0"
              :verified="2"
              :plan="1"
              mandatory
          ></WebsiteWrapper>
        </template>
        <template #content>
          <v-row>
            <v-col cols="12">
              <div class="tw-mt-4 tw-font-semibold">
                {{ $t("websites.reviews_params.form.order_title") }}
              </div>
              <v-radio-group v-model="params.order">
                <v-radio
                  :disabled="!params.website_id > 0"
                  :label="$t('websites.reviews_params.form.order_last_label')"
                  value="last"
                ></v-radio>
                <v-radio
                  :disabled="!params.website_id > 0"
                  :label="$t('websites.reviews_params.form.order_best_label')"
                  value="best"
                ></v-radio>
                <v-radio
                  :disabled="!params.website_id > 0"
                  :label="$t('websites.reviews_params.form.order_pertinent_label')"
                  value="pert"
                ></v-radio>
                <v-radio
                  :disabled="!params.website_id > 0"
                  :label="$t('websites.reviews_params.form.order_liked_label')"
                  value="like"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <div class="tw-mt-1 tw-font-semibold">
                {{ $t("websites.reviews_params.form.exclude_title") }}
              </div>

              <v-checkbox
                  hide-details
                  v-model="params.selection.exclude_free"
                  :disabled="!params.website_id > 0"
                  :label="$t('websites.reviews_params.form.exclude_free_label')"
                  :value="true"
              ></v-checkbox>

              <v-checkbox
                  hide-details
                  v-model="params.selection.exclude_thematics"
                  :disabled="!params.website_id > 0"
                  :label="$t('websites.reviews_params.form.exclude_thematic_label')"
                  :value="true"></v-checkbox>
              <div class="tw-ml-8 tw-mr-20">
                <FormField
                    v-model="params.selection.filter_thematics"
                    :readOnly="!(params.selection.exclude_thematics===true)"
                    i18n="websites.reviews_params.form.filter_thematic_label"
                    input-type="text"/>
              </div>


              <v-checkbox
                  hide-details
                  v-model="params.selection.exclude_products"
                  :disabled="!params.website_id > 0"
                  :label="$t('websites.reviews_params.form.exclude_product_label')"
                  :value="true"
              ></v-checkbox>
              <div class="tw-ml-8 tw-mr-20">
                <FormField v-model="params.selection.filter_products"
                    :readOnly="!(params.selection.exclude_products===true)"
                    i18n="websites.reviews_params.form.filter_product_label"
                    input-type="text"/>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <div class="tw-mt-1 tw-font-semibold">
                {{ $t("websites.reviews_params.form.age_selection") }}
              </div>
              <div class="tw-mt-1 tw-ml-8 tw-mr-20">
                <v-select class=""
                          hide-details
                          v-model="params.selection.max_age"
                          :items="max_ages"
                          :label="$t('websites.reviews_params.form.max_age')"
                          col="6"
                          item-text="label"
                          item-value="val"
                ></v-select>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <div class="tw-mt-1 tw-font-semibold">
                {{ $t("websites.reviews_params.form.legal_link_title") }}
              </div>
              <div class="tw-mt-1 tw-ml-8 tw-mr-20">
                <FormField
                    v-model="params.selection.legal_link"
                    i18n="websites.reviews_params.form.legal_link_placeholder"
                    input-type="text"/>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <div class="tw-mt-1 tw-font-semibold">
                {{ $t("websites.reviews_params.form.ext_review_url_title") }}
              </div>
              <div class="tw-mt-1 tw-ml-8 tw-mr-20">
                <FormField
                    v-model="params.selection.ext_review_url"
                    i18n="websites.reviews_params.form.ext_review_url_placeholder"
                    input-type="text"/>
              </div>
            </v-col>
          </v-row>
          <v-btn
            :disabled="!params.website_id > 0"
            class="tw-mt-4 float-right"
            color="primary"
            small
            @click="paramsSend()"
          >
            {{ $t("websites.reviews_params.bt.send") }}
          </v-btn>
        </template>
      </TabPage>
      <!-- ------------------------ Liste des thématiques ------------------------ -->
      <TabPage :menu="menu" :page="page" no-documentation name="thematics_params">
        <template #content>
          <v-container>
            <!-- Main dialog thematics updates -->
            <v-dialog v-model="thematicDialog" max-width="900">
              <v-card>
                <v-card-title v-if="thematic.new" class="headline" >
                  {{ $t("thematics.form.new") }}
                </v-card-title>
                <v-card-title v-else class="headline" >
                  {{ $t("thematics.dialogs.main.title") }} {{ thematic.id }}
                </v-card-title>
                <v-card-text class="mt-4">
                  <v-row>
                    <v-col>
                      <div class="mt-1">{{ $t('thematics.table.id') }}</div>
                      <v-text-field v-if="thematic.new" v-model="thematic.code"
                          solo
                          type="text"
                          :placeholder="$t('thematics.dialogs.main.newcode')"
                      ></v-text-field>
                      <v-text-field v-else v-model="thematic.id"
                          solo
                          type="text"
                          :readonly="true"
                      ></v-text-field>

                      <div class="mt-1 mb-3">
                        {{ $t('thematics.table.scope') }}
                        <br>
                        <span v-if="isThematicsForCountry(thematic,'gb')"><img src="/flags/gb.png" /></span>
                        <span v-if="isThematicsForCountry(thematic,'fr')"><img src="/flags/fr.png" /></span>
                        <span v-if="isThematicsForCountry(thematic,'es')"><img src="/flags/es.png" /></span>
                        <span v-if="isThematicsForCountry(thematic,'it')"><img src="/flags/it.png" /></span>
                        <span v-if="isThematicsForCountry(thematic,'de')"><img src="/flags/de.png" /></span>
                        <span v-if="isThematicsForCountry(thematic,'pt')"><img src="/flags/pt.png" /></span>
                        <span v-if="isThematicsForCountry(thematic,'nl')"><img src="/flags/nl.png" /></span>
                      </div>

                      <div class="mt-1">{{ $t('thematics.table.thematic') }}</div>
                      <v-text-field
                          solo
                          type="text"
                          v-model="thematic.thematic"
                          :readonly="!(thematic.company_id>0)"
                      ></v-text-field>

                      <div class="mt-2">{{ $t('thematics.table.description') }}</div>
                      <v-textarea
                          solo
                          v-model="thematic.description"
                          :readonly="!(thematic.company_id>0)"
                      ></v-textarea>
                    </v-col>
                  </v-row>

                </v-card-text>
                <v-card-actions>
                  <v-spacer/>
                  <v-btn color="" text @click="thematicDialog = false">
                    {{ $t("common.cancel") }}
                  </v-btn>
                  <v-btn v-if="!thematic.new&&thematic.company_id>0" color="warning" text @click="deleteThematic()">
                    {{ $t("common.delete") }}
                  </v-btn>
                  <v-btn v-if="!thematic.new&&thematic.company_id>0" color="success" text @click="saveThematic()">
                    {{ $t("common.save") }}
                  </v-btn>
                  <v-btn v-if="thematic.new" color="success" text @click="createThematic()">
                    {{ $t("common.save") }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <div class="sr-title tw-mb-4">

              <span class="pt-1">{{ $t("thematics.form.title") }}</span>
              <v-btn depressed :elevation="thematicsSelectedCountry==='*'?1:6" x-small style="margin-left: 5px;" @click="getThematics('*')" >Mes sujets</v-btn>
              <span class="pt-1">{{ $t("thematics.form.title_generic") }}</span>
              <v-btn depressed :elevation="thematicsSelectedCountry==='fr'?1:6" x-small style="margin-left: 5px;" @click="getThematics('fr')" ><img src="/flags/fr.png" /></v-btn>
              <v-btn depressed :elevation="thematicsSelectedCountry==='gb'?1:6" x-small style="margin-left: 5px;" @click="getThematics('gb')" ><img src="/flags/gb.png" /></v-btn>
              <v-btn style="float: right;" :title="$t('thematics.refresh')" icon @click="getThematics">
                <v-icon x-small>
                  fa-sync-alt
                </v-icon>
              </v-btn>
              <v-btn style="float: right;" small :title="$t('thematics.new')" @click="newThematics">
                {{ $t("thematics.form.new") }}
              </v-btn>
            </div>

            <!-- Table that contain all added thematics -->
            <v-data-table :items="thematics"
                :headers="thematicsDatatableHeaders"
                :items-per-page="10"
                item-key="id"
                :search="thematicsSearch"
            >
              <template v-slot:item.thematic="{ item }">
                <b>{{ item.thematic }}</b>
                <br>
                <div class="ml-3 mt-1 mb-1">
                  <i style="white-space: pre-line;">{{ item.description }}</i>
                </div>
              </template>
              <template v-slot:item.scope="{ item }">
                <span v-if="isThematicsForCountry(item,'gb')"><img src="/flags/gb.png" /></span>
                <span v-if="isThematicsForCountry(item,'fr')"><img src="/flags/fr.png" /></span>
                <span v-if="isThematicsForCountry(item,'es')"><img src="/flags/es.png" /></span>
                <span v-if="isThematicsForCountry(item,'it')"><img src="/flags/it.png" /></span>
                <span v-if="isThematicsForCountry(item,'de')"><img src="/flags/de.png" /></span>
                <span v-if="isThematicsForCountry(item,'pt')"><img src="/flags/pt.png" /></span>
                <span v-if="isThematicsForCountry(item,'nl')"><img src="/flags/nl.png" /></span>
              </template>
              <template v-slot:item.actions="{ item }">
                <div class="sr-flex-row">
                  <v-btn
                      v-if="item.company_id>0"
                      :title="$t('products.product_list.actions.edit')"
                      icon
                      small
                      @click="showThematicDialogue(item)"
                  >
                    <v-icon small>fas fa-edit</v-icon>
                  </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-container>
        </template>
      </TabPage>
    </template>
  </Tab>
</template>

<script>
import tab from "../../../../mixins/tab"
import { Types as TypesSnackbar } from "../../../../store/modules/snackbar"
import WebsiteWrapper from "@/components/common/Form/WebsiteWrapper"

export default {
  name: "Parameters",
  components: {
    WebsiteWrapper,
  },
  mixins: [tab],
  data: () => ({
    pages: ["profiles"],
    menu: "parameters",
    page: "profiles",
    profile: null,
    selectedProfile: null,
    profiles: [],
    counters: [],
    creatorMode: false,
    snackbar: false,
    snackbarTimeout: 2000,
    snackbarText: "",
    snackbarColor: "success",
    params_websites: [],
    valid: false,
    max_ages: [
      { val: "3M", label: "Trois mois d'ancienneté" },
      { val: "6M", label: "Six mois d'ancienneté" },
      { val: "12M", label: "Une année d'ancienneté" },
      { val: "99M", label: "Sans limite d'ancienneté" },
    ],
    params: {
      order: "last",
      selection: {
        exclude_free: false,
        exclude_thematics: false,
        filter_thematics: '',
        exclude_products: false,
        filter_products: '',
        legal_link: '',
        ext_review_url: '',
        max_ages: '99M',
      },
      website_id: 0,
    },
    thematicDialog: false,
    thematics: [],
    thematicsSelectedCountry: 'fr',
    thematic: {},
    thematicsDatatableHeaders: [],
    thematicsSearch: ""
  }),
  mounted() {
    this.buildThematcisDatatableHeaders()
    this.fetchProfiles()
    this.fetchWebsites()
    this.getThematics()
  },
  watch: {
    selectedProfile(value) {
      if (value !== undefined && value !== null) {
        this.creatorMode = false
        this.profile = { ...this.profiles[value] }
        this.fetchProfileCounters()
      } else {
        this.profile = null
      }
    },
  },
  methods: {
    fetchWebsites() {
      this.$axios.get("/office/manager/pages/websites?for=publications").then(response => {
        this.params_websites = response.data
        this.params.website_id = this.params_websites[0]["id"]
        this.loadWebsitePublicationsParams()
      })
    },
    loadWebsitePublicationsParams() {
      this.$axios
        .get("/office/manager/publications/params?website_id=" + this.params.website_id)
        .then(response => {
          this.params.order = response.data.order
          this.params.selection.exclude_free = response.data.exclude_free
          this.params.selection.exclude_thematics = response.data.exclude_thematics
          this.params.selection.filter_thematics = response.data.filter_thematics
          this.params.selection.exclude_products = response.data.exclude_products
          this.params.selection.filter_products = response.data.filter_products
          this.params.selection.max_age = response.data.max_age
          this.params.selection.legal_link = response.data.legal_link
          this.params.selection.ext_review_url = response.data.ext_review_url
        })
        .catch(() => {
          this.params.order = "last"
          this.params.selection.exclude_free = true
          this.params.selection.exclude_thematics = true
          this.params.selection.filter_thematics = ""
          this.params.selection.exclude_products = true
          this.params.selection.filter_products = ""
          this.params.selection.legal_link = ""
          this.params.selection.ext_review_url = ""
          this.params.selection.max_age = "99M"
        })
    },
    paramsSend() {
      this.$axios
        .post("/office/manager/publications/params", {
          website_id: this.params.website_id,
          order: this.params.order,
          exclude_free: this.params.selection.exclude_free,
          exclude_thematics: this.params.selection.exclude_thematics,
          filter_thematics: this.params.selection.filter_thematics,
          exclude_products: this.params.selection.exclude_products,
          filter_products: this.params.selection.filter_products,
          legal_link: this.params.selection.legal_link,
          ext_review_url: this.params.selection.ext_review_url,
          max_age: this.params.selection.max_age })
        .then(() => {
          this.snackbarText = this.$t("websites.reviews_params.messages.sendDone")
          this.snackbarColor = "success"
          this.snackbarTimeout = 4 * 1000
          this.snackbar = true
        })
        .catch(() => {
          this.snackbarText = this.$t("websites.reviews_params.messages.sendError")
          this.snackbarColor = "warning"
          this.snackbarTimeout = 4 * 1000
          this.snackbar = true
        })
    },
    fetchProfiles() {
      this.$axios
        .get("office/manager/profiles/list")
        .then(response => {
          this.profiles = response.data
        })
        .catch(() => this.handleError("parameters.profiles.error.fetch_profiles"))
    },
    fetchProfileCounters() {
      this.$axios
        .get("office/manager/profile/" + this.profile.id + "/counters")
        .then(response => {
          this.counters = response.data.counters
        })
        .catch(() => this.handleError("parameters.profiles.error.fetch_counters"))
    },
    handleError(i18n = "") {
      this.$store.dispatch(TypesSnackbar.actions.PUSH_MESSAGE, {
        lines: this.$t(i18n),
        config: { timeout: 1000 * 6, color: "error" },
      })
    },
    newProfile() {
      this.selectedProfile = null
      this.creatorMode = true

      this.$nextTick(() => {
        this.profile = {}
      })
    },
    createProfile() {
      this.$axios
        .post("office/manager/profile", this.profile)
        .then(response => {
          this.profiles.push(response.data)
        })
        .catch(() => this.handleError("parameters.profiles.error.create_profile"))
    },
    updateProfile() {
      this.$axios
        .patch("office/manager/profile/" + this.profile.id, this.profile)
        .then(() => {
          this.profiles[this.selectedProfile] = { ...this.profile }
          this.profile = null
          this.selectedProfile = null
        })
        .catch(() => this.handleError("parameters.profiles.error.update_profile"))
    },
    deleteProfile() {
      this.$axios
        .delete("office/manager/profile/" + this.profile.id)
        .then(() => {
          this.profiles = this.profiles.filter((value, index) => index !== this.selectedProfile)
          this.cancelProfile()
        })
        .catch(() => this.handleError("parameters.profiles.error.delete_profile"))
    },
    cancelProfile() {
      this.profile = null
      this.creatorMode = false
      this.selectedProfile = null
    },
    showThematicDialogue(thematic) {
      this.thematic = thematic
      this.thematicDialog = true
    },
    getThematics( country=null) {
      if(country) {
        this.thematicsSelectedCountry = country
      }
      this.$axios.get("/office/manager/thematics/index").then(response => {
        this.thematics = response.data.filter( item => this.isThematicsForCountry(item,this.thematicsSelectedCountry))
      })
    },
    isThematicsForCountry(item,country) {
      // 1000100 -> fr, 1010100 -> en, 1020100 -> es, 2000100 -> fr, 2010100 -> en, 2020100 -> es, etc
      let countryId = Math.trunc(item.id / 10000)
      countryId = countryId - Math.trunc(countryId/100)*100 ;

      if(item.id<1000000000) {
        if ((countryId === 0) && (country === 'fr')) return true
        if ((countryId === 1) && (country === 'gb')) return true
        if ((countryId === 2) && (country === 'es')) return true
        if ((countryId === 3) && (country === 'it')) return true
        if ((countryId === 4) && (country === 'de')) return true
        if ((countryId === 5) && (country === 'pt')) return true
        if ((countryId === 6) && (country === 'nl')) return true
      }

      if((item.id>1000000000)&&(country==='*')) return true
      return false
    },
    openThematicDialog(thematic) {
      this.thematic = thematic;
      this.thematicDialog = true
    },
    newThematics() {
      this.thematic = { new: true, code: '' , company_id: 99 , thematic: "" , description: "" };
      this.thematicDialog = true
    },
    saveThematic() {
      this.$axios
          .post("/office/manager/thematics/"+this.thematic.id, this.thematic)
          .then(() => {
            this.thematicDialog = false
          })
          .catch(() => (this.thematicDialog =false))
    },
    deleteThematic() {
      if(confirm(this.$t('thematics.form.delete'))) {
        this.$axios
            .delete("office/manager/thematics/" + this.thematic.id, this.thematic)
            .then(() => {
              this.getThematics()
              this.thematicDialog = false
            })
            .catch(() => (this.thematicDialog = false))
      }
    },
    createThematic() {
      this.$axios
          .post("/office/manager/thematics/", this.thematic)
          .then(() => {
            this.getThematics()
            this.thematicDialog = false
          })
          .catch(() => (this.thematicDialog = false))
    },
    buildThematcisDatatableHeaders() {
      this.thematicsDatatableHeaders = [
        {
          text: this.$t("thematics.table.id"),
          align: "start",
          value: "id",
        },
        {
          text: this.$t("thematics.table.scope"),
          align: "start",
          value: "scope",
        },
        {
          text: this.$t("thematics.table.thematic"),
          align: "start",
          value: "thematic",
        },
        {
          text: this.$t("thematics.table.actions"),
          align: "start",
          value: "actions",
        },

      ]
    },
  },
}
</script>

